export default {
  // ========== Form fields ==========
  fullName: 'Full Name',
  email: 'Email',
  position: 'Position',
  institution: 'Institution',
  country: 'Country',
  phone: 'Phone',
  message: 'Message',

  // ========== Buttons ==========
  send: 'Send',

  // ========== Titles and messages ==========
  contactUsTitle: 'Contact Us!',
  contactDescription: 'If you are looking for a comprehensive solution for curriculum design and the monitoring of learning outcomes, Key Learning is the answer: it automatically and intelligently connects curriculum and assessment, generating key insights to guide decision-making and contribute to the continuous improvement of educational quality.',
  messageSent: 'Message sent!!!',

  // ========== Contact banner ==========
  companyName: 'Key Learning SPA',
  address: 'Cerro El Plomo',
  addressDetail: '#5931, Office N°510, Las Condes, Santiago.',
  copyright: 'Copyright © KEY LEARNING SPA {year}. All rights reserved.',

  // ========== reCAPTCHA ==========
  recaptchaAttribution: 'This site is protected by reCAPTCHA and the Google',
  recaptchaPrivacyPolicy: 'Privacy Policy',
  recaptchaAnd: 'and',
  recaptchaTermsOfService: 'Terms of Service',
  recaptchaApply: 'apply.',
}
